module.exports = __webpack_public_path__ + "images/back268481654706fbe83053b0e1a4fac33d.svg";